import React from 'react';
import '../../AdvantagesBlock/less/main.less';
import DOMPurify from 'utils/sanitize';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../helpers/canUseDOM';

export default function template() {
  const { data, loader } = this.props;

  if (loader) {
    return canUseDOM ? <Preloader /> : null;
  }

  if (!data || !data.data || !data.data.length) {
    return null;
  }

  return (
    <div className={`advantages advantages_${data.data.length}`}>
      <div className="container">
        {data.title && (
          <h2
            className="advantages__title"
            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(data.title))}}
          >
          </h2>
        )}
        <div className="advantages__row">
          {[...data.data].sort((a, b) => a.order - b.order).map((item, index) => (
            <div
              className={`advantages__item item-advantages item-advantages_${index + 1}`}
              key={item.id}
            >
              {item.image_url && (
                <img
                  className="item-advantages__image"
                  src={item.image_url}
                  alt={this.l10n(item.green_text) || ''}
                />
              )}
              <div className="item-advantages__body">
                {item.green_text && (
                  <h3
                    className="item-advantages__title"
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.green_text))}}
                  >
                  </h3>
                )}
                {item.explanation_text && (
                  <div
                    className="item-advantages__text"
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.explanation_text))}}
                  >
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
